document.addEventListener("DOMContentLoaded", () => {
  const applyLayout = () => {
    document.querySelectorAll("shopify-forms-embed").forEach((formEmbed) => {
      const shadow = formEmbed.shadowRoot;
      if (!shadow) return;
      if (shadow.querySelector("#custom-flex-layout")) return;

      const style = document.createElement("style");
      style.id = "custom-flex-layout";
      style.textContent = `
        ._formContainer_1q1d2_30 {
          width: 100% !important;
          max-width: 600px !important;
          margin: 0 auto !important;
        }

      `;
      shadow.appendChild(style);
    });
  };

  applyLayout();
  [300, 800, 1500, 3000].forEach(ms => setTimeout(applyLayout, ms));
});